export default "__VITE_ASSET__Cn6Zty1I__"